import { OrderModalBtn } from "./OrderModalBtn/OrderModalBtn";
import { OrderDetailsModalBtn } from "./OrderDetailsModalBtn/OrderDetailsModalBtn";
import { DefaultBtn } from "./DefaultBtn/DefaultBtn";
import { PrefixesBtn } from "./PrefixesBtn/PrefixesBtn";
import { PurchaseRecommendationTableBtn } from "./PurchaseRecommendationTableBtn/PurchaseRecommendationTableBtn";

export const BUTTONS_STRATEGY_CONSTANTS = Object.freeze({
  ORDER_DETAILS_MODAL: 'order_details_modal',
  ORDER_MODAL: 'order_modal',
  DEFAULT: 'default',
  PURCHASE_RECOMMENDATION_TABLE: 'purchase_recommendation_table',
  PREFIXES: 'prefixes'
});

const buttonDisplayStrategySelector = (mode) => {
  switch (mode) {
    case BUTTONS_STRATEGY_CONSTANTS.ORDER_MODAL:
      return OrderModalBtn;
    case BUTTONS_STRATEGY_CONSTANTS.ORDER_DETAILS_MODAL:
      return OrderDetailsModalBtn;
    case BUTTONS_STRATEGY_CONSTANTS.PREFIXES: 
        return PrefixesBtn;
    case BUTTONS_STRATEGY_CONSTANTS.PURCHASE_RECOMMENDATION_TABLE:
        return PurchaseRecommendationTableBtn;
    default:
      return DefaultBtn;
  }
};

export const ButtonDisplayStrategy = ({ actions, ctx, uiState, mode = BUTTONS_STRATEGY_CONSTANTS.DEFAULT }) => {
  const StrategyComponent = buttonDisplayStrategySelector(mode);
  return <StrategyComponent actions={actions} ctx={ctx} uiState={uiState} />;
};